import { type GalleryItem, type GallerySection } from '../types';
import { boxesToRows } from './boxesToRows';

export function sectionsToRows<T = object>(sections: GallerySection<T>[]) {
  const lastSectionIndex = sections.length - 1;

  return sections.reduce((acc, section, sectionIndex) => {
    const isLastSection = sectionIndex === lastSectionIndex;

    if (section.header) {
      acc.push([{ ...section.header, index: 0 }]);
    }

    if (section.items) {
      const rows = boxesToRows(section.items.boxes);
      const lastRowIndex = rows.length - 1;
      const itemRows = rows.map((items, rowIndex) =>
        items.map((item) => ({
          ...item,
          ...section.items,
          isLastRowOfLastSection: isLastSection && rowIndex === lastRowIndex,
          isLastRowOfSection: rowIndex === lastRowIndex,
          sectionId: `section-${sectionIndex}`,
        })),
      );
      acc.push(...itemRows);
    }

    if (section.footer) {
      acc.push([{ ...section.footer, index: 0 }]);
    }

    return acc;
  }, [] as GalleryItem<T>[][]);
}
